import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import { IMMCDetails } from '@irb/irb-dashboard/irb-dashboard.model';
import { IApplyFilterOnLanding } from '@irb/app.model';
import {faBell,faChevronRight,faClock, faDownload} from '@fortawesome/free-solid-svg-icons';
import {BannerService} from '@irb-common/components/banner/banner.service';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';
import {UtilityService} from "@irb-common/services/utility.service";

@Component({ standalone: false,
  selector: 'irb-com-mmc',
  templateUrl: './com-mmc.component.html',
  styleUrls: ['./com-mmc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComMmcComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private _data: IMMCDetails;
    mmcMonthlyBillingSummaryRecent: Array<any> = [];
    mmcMonthlyBillingSummaryPrev: Array<any> = [];
    selectedMnthYr: any;
    selectedMnthYrValue: number = -1;
    invoicesList: Array<any> = [];
    faBell = faBell;
    faDownload = faDownload;
    showBell = false;
    selectedIndex: number = 0;
    aumFormatted: string = '';
    timestamp: any;
    @ViewChild('IrbDropdownPreviousMonths') IrbDropdownPreviousMonths: any;

  constructor(
      public as: AppService,
      public ps: PageService,
      private dbs: IrbDashboardService,
      private cdr: ChangeDetectorRef,
      private router: Router,
      private bs: BannerService,
      private util: UtilityService,
      private ats: AnalyticsService
  ) {}

  ngOnInit() {
    this.getData();
  }
  refreshWidgetData() {
    this.data = null;
    this.getData();
  }
  getData() {
    const d = this.util.getEasternTime(new Date().getTime());
    this.timestamp = this.util.formatDateTimeString(new Date(d), "MM/dd/yyyy hh:mm tt") + ' ET';
    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
      if(d) {
        this.dbs.getMMCDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
          this.data = d as IMMCDetails;
          this.aumFormatted = UtilityService.formatAmountWithAbbreviation(this.data.aum);
          this.cdr.detectChanges();
        });

        this.dbs.getAdvisorInvoiceList().subscribe((invoices: any) => this.getMMCMonthlyBillingSummary(invoices));
      }
    });
  }
  showModelMarketCenter() {
    this.ats.trackPassiveEvent("lc_mmc");
    this.router.navigate(['/models/model-market-center']);
  }

  showModelsWithUnreadChanges() {
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'withoutUnread', value:true, isUpdatRequired:true}
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl("/models/models", { state: state });
  }
  showModelsPausedForReview() {
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'isPaused', value:true, isUpdatRequired:true}
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl("/models/models", { state: state });
  }
  showSubscribedModels() {
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'isMMCModel', value:['Yes'], isUpdatRequired:true}
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/models/models', { state: state });
  }
  showAssignedPortfolios() {
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'isAssignedMMC', value:['Yes'], isUpdatRequired:true}
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/clients/portfolios', { state: state });
  }

  get data() {
    return this._data;
  }

  set data(d: IMMCDetails) {
    this._data = d;
  }

  private getMMCMonthlyBillingSummary(invoices: any) {
      if (invoices && invoices.length !== 0) {

          this.bs.getAlerts().subscribe((data: any) => {
              if (data && data.length !== 0) {
                  for (let i = 0; i < data.length; i++) {
                      if (data[i].type === 'MMC_INVOICE') {
                          this.showBell = true;
                          break;
                      }
                  }
              }
          });

          this.invoicesList = invoices;
          let newEl: any;
          this.mmcMonthlyBillingSummaryRecent = [];
          this.mmcMonthlyBillingSummaryPrev = [];
          for (let i = 0; i < invoices.length; i++) {
              newEl = {
                  value: invoices[i].id,
                  name: this.getMonthYearFmt(invoices[i].period)
              };
              this.mmcMonthlyBillingSummaryRecent.push(newEl);
              if (i === 2) {
                  break;
              }
          }

          for (let i = 3; i < invoices.length; i++) {
              newEl = {
                  value: invoices[i].id,
                  name: this.getMonthYearFmt(invoices[i].period)
              };
              this.mmcMonthlyBillingSummaryPrev.push(newEl);
          }
      }
      this.cdr.detectChanges();
  }

  private getMonthYearFmt(v: number) {
      const d = new Date(v);
      const month = d.toLocaleString('en-US', {timeZone: 'America/New_York', month: 'long'});
      const yyyy = d.getFullYear();
      return month + ' ' + yyyy;
  }

  getPreviousMonths(searchStr: any) {
      const f = DropdownFilterComponent.getFilteredList(searchStr, this.mmcMonthlyBillingSummaryPrev);
      this.IrbDropdownPreviousMonths.set(f);
  }

  onSelectMonthYear(item: any) {
      this.selectedMnthYrValue = item.value;
  }

  viewMMCMonthlyBillingSummary(id: number) {
      let invoiceName: string = 'AdvisorInvoice';

      if (this.invoicesList.length !== 0) {
          const invoice = this.invoicesList.filter((inv: any) => {
              return inv.id === id;
          });

          if (invoice && invoice.length !== 0) {
              const d = new Date(invoice[0].period);
              const month = d.getMonth() + 1;
              const yyyy = d.getFullYear();
              invoiceName += '_' + month + '-' + yyyy;
          }
      }

      this.dbs.downloadInvoices(id).subscribe((res: any) => {
          const blob: any = new Blob([(res)], {type: 'application/pdf'});
          const data = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = data;
          link.download = invoiceName;
          link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
      });
  }
  selectedTabChange() {
    this.selectedMnthYrValue = -1;
    this.selectedMnthYr = null;
  }
protected readonly faClock = faClock; protected readonly faChevronRight = faChevronRight; }
